import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ErrorService } from '../services/error.service';
import { SpinnerService } from '../services/spinner.service';
import { UserService } from '../services/user.service';

@Injectable()
export class CanActivateAuthGuard implements CanActivate {

	constructor(public _userService: UserService,
				public _router: Router,
				public _authenticationService: AuthenticationService,
				private _spinnerService: SpinnerService,
				private _errorService: ErrorService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		return new Promise((resolve) => {
			const user = this._userService.getUser();
			if (user && user.token) {
				if (state.url.includes('invoices') && (!user.inetUser || !user.inetUser.viewInvoices)) {
					resolve(false);
				} else if (state.url.includes('address-book') && (!user.inetUser || !user.inetUser.allowAddressBookAccess)) {
					resolve(false);
				} else if (state.url.includes('order-templates') && !user.allowRecentTemplates) {
					resolve(false);
				}
				if (user.type === 'inet') {
					if (state.url === '/' ||
						state.url.includes('work') ||
						state.url.includes('login') ||
						state.url.includes('register') ||
						state.url.includes('settlements') ||
						state.url.includes('estimated-settlements')) {
						this._router.navigate(['place-order']);
					}
				} else if (user.type === 'worker') {
					if (state.url === '/' ||
						state.url.includes('address-book') ||
						state.url.includes('login') ||
						state.url.includes('register') ||
						state.url.includes('place-order') ||
						state.url.includes('track-parcel') ||
						state.url.includes('order-confirmation') ||
						state.url.includes('track-order') ||
						state.url.includes('route-tracking') ||
						state.url.includes('reports') ||
						state.url.includes('order-templates') ||
						state.url.includes('invoices')) {
						this._router.navigate(['work']);
					}
				}
				return this.renewSession().then((res) => {
					resolve(res);
				});
			} else if ((route.params['userId'] || route.params['userid']) && (route.params['password'] || route.params['Password'] ) && (route.params['type'] || route.params['Type'])) {
				this.loginUser({
					username: route.params['userid'] ?? route.params['userId'],
					password: route.params['password']?? route.params['Password']
				}, (route.params['type']?? route.params['Type']), route, state.url);
				resolve(false);
			} else if ((state.url.includes('reset') && route.params['token'] && (route.params['userId'] || route.params['userid'])) || state.url.includes('track-order') || state.url.includes('register') || state.url.includes('attachments')) {
				resolve(true);
			} else {
				this._authenticationService.showAuthModal();
				resolve(state.url.includes('home'));
			}
		});
	}

	loginUser(creds, type, route, url) {
		let trackingIds: any;
		this._authenticationService.initiateLogin(creds, type).subscribe({
			next: (response) => {
				url = url.substr(0, url.indexOf(';'));
				trackingIds = route.params.trackingId;
				if (trackingIds) {
					this._router.navigate([url ? url : response, {trackingId: trackingIds}]);
				} else {
					this._router.navigate([url ? url : response]);
				}
			}, error: (error) => {
				console.log(error);
			}
		});
	}

	renewSession(): Promise<boolean> {
		return new Promise((resolve) => {
			const user = this._userService.getUser();
			if (user && user.token) {
				this._spinnerService.startSpinner();
				return this._authenticationService.renewSession(user).subscribe({
					next: (response: boolean) => {
						this._spinnerService.stopSpinner();
						if (response === true) {
							resolve(true);
						} else {
							this._userService.deleteUser();
							this._authenticationService.showAuthModal();
							resolve(false);
						}
					}, error: (error) => {
						this._errorService.error(error, 'Renew session failed', 'modal');
						this._spinnerService.stopSpinner();
						resolve(false);
					}
				});
			} else {
				resolve(false);
			}
		});
	}
}
